import React from "react";

import { hasKey } from "@helpers/utils";

import defaultFieldRenderer from "../defaultFieldRenderer";
import type { FieldRenderer } from "../types";
import type { FieldRendererComponentProps } from "./types";

const IDRenderer = React.memo(function IDRenderer({
  fieldValue,
  onCopySuccess,
}: FieldRendererComponentProps & { onCopySuccess?: () => void }) {
  const defaultNode = defaultFieldRenderer(
    fieldValue,
    undefined,
    onCopySuccess,
  ).node;
  const defaultNodeClassName = hasKey(defaultNode.props, "className")
    ? defaultNode.props.className
    : "";

  return React.cloneElement(
    defaultFieldRenderer(fieldValue, undefined, onCopySuccess).node,
    {
      className: defaultNodeClassName,
    },
  );
});

const renderer: FieldRenderer = (
  fieldValue: unknown,
  tooltipValue?: unknown,
  onCopySuccess?: () => void,
) => {
  const formattedText = String(fieldValue);
  return {
    formattedText,
    node: (
      <IDRenderer
        fieldValue={fieldValue}
        formattedText={formattedText}
        onCopySuccess={onCopySuccess}
      />
    ),
  };
};

export default renderer;
